import React, { Component } from 'react';
import Buttons from '../Buttons';
class ModalHeader extends Component {
    
    render () {
        return (
            <>
            <div className="modal-header">
                <h5 className={`modal-title secondary_color ${this.props.titleClass}`} id="staticModalLabel"> 
                    {this.props.Title}
                </h5>
                <div className='btn-right'>
                    <Buttons buttonList={this.props.headerButtonList}/>
                </div>
            </div>
            </>
            
            
        )
    }
}

export default ModalHeader;